import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { withRouter } from 'react-router-dom'
import Cookies from 'js-cookie'
import DongfengIndex from './project/dongfeng/FrontendIndex/index'
import asyncComponent from './components/commons/AsyncComponent'
import icons from './favicon.ico'

const Login = asyncComponent(() => import('./components/Layout/Login'))



@inject('appStore') @withRouter @observer
export default class App extends Component {

    componentDidMount(){

        let title='',href='',icon='';
        switch(this.props.appStore.company.company){
            case 'dongfeng': {
                title='奕派科技售后技术服务平台';
                href=icons;
                break;
            }
                default:
                    break;
        }
        document.title = title
        this.createFavicon(href)
        this.externalInterfaceLogin();
    }
    selectPage = ()=>{
        switch(this.props.appStore.company.company){
            case 'dongfeng': return <DongfengIndex/>
            default:break;
        }
    }
    createFavicon(href){
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = href;
        document.getElementsByTagName('head')[0].appendChild(link);
    }

    externalInterfaceLogin() {
        let cookies = Cookies.get('cf81sessionid');
        this.props.appStore.externalInterfaceLogin(cookies)
    }

    render () {
        const { isLogin } = this.props.appStore
        return isLogin ? (
               <div>
                   {this.selectPage()}
               </div>
            ) : <Login/>
    }
}


// WEBPACK FOOTER //
// ./src/App.js